<template>
  <div class="prm-new">
    <main-head>
      <template v-slot:pageName>
        {{ $t("page.prmAudit.title") }}
      </template>
      <template v-slot:headBtn>
        <el-button type="primary" @click="toList">{{ $t('common.preReturnBtn') }}</el-button>
      </template>
    </main-head>
    <prm-detail ref="mydetail" />
    <operation-logs />
    <div v-if="canAudit">
      <div style="margin: 30px 0;">
        <i class="iconfont icon-navicon-bmfa formtitle" /><span
          class="formtitle"
        >{{ $t('page.prmAudit.remarksApproval') }}</span>
      </div>
      <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" v-model="Approvaltext" maxlength="500" />

      <!-- <div style="margin: 30px 0;">
        <el-button class="submit" size="medium" @click="submit(true, false)" plain>{{ $t("message.agree") }}</el-button>
        <el-button class="cancle" v-if="canRejectedPre" size="medium" plain @click="submit(false, false)">{{ $t("message.reject") }}</el-button>
        <el-button class="cancle" v-if="canRejectedFirst" size="medium" plain @click="submit(false, true)">{{ $t("message.rejectToFirst") }}</el-button>
      </div> -->
    </div>
  </div>
</template>

<script type="es6">
import API from '../../API';
import { formate } from '../../libs/mixin';
import mainHead from '../component/mainHead';
import prmDetail from '../component/prmDetail';
import eventBus from '../../libs/eventBus';
import OperationLogs from '../component/OperationLogs';
export default {
  name: 'PrmAudit',
  mixins: [formate],
  data () {
    return {
      Approvaltext: '',
      Reject: {},
      canAudit: false,
      canRejectedPre: false,
      canRejectedFirst: false
    };
  },
  components: {
    OperationLogs,
    mainHead,
    prmDetail
  },
  methods: {
    toList () {
      window.history.go(-1);
    },

    submit (allow, isRejectedFirst) {
      let id = this.$route.query.objectId;
      if (id) {
        if (!this.Approvaltext || this.Approvaltext.trim() === '') {
          this.$notify.error({
            title: this.$t('message.needOpinion')
          });
          return;
        }
        this.pageloading = true;
        API.salesAudit({
          approvalOpinion: this.Approvaltext,
          objectId: id,
          isPass: allow,
          isRejectedFirst: isRejectedFirst
        }).then((res) => {
          let json = res.data;
          this.pageloading = false;
          if (json.status === '200') {
            this.$refs.mydetail.init();
            window.scroll(0, 0);
            this.Approvaltext = '';
            this.$notify({
              title: this.$t('message.submitSuccess'),
              type: 'success'
            });
            this.toList();
          } else {
            this.$notify.error({
              title: this.$t('message.submitError')
            });
          }
        }).catch(() => {
          this.pageloading = false;
          this.$notify.error({
            title: this.$t('message.submitError')
          });
        });
      }
    }
  },
  mounted () {
    eventBus.$on('currentStep', (currentStep) => {
      console.log(currentStep);
      this.canAudit = currentStep.canAudit;
      this.canRejectedPre = currentStep.isRejectedPre;
      this.canRejectedFirst = currentStep.isRejectedFirst;
    });
  },
  destroyed () {
    eventBus.$off('currentStep');
  },
  watch: {

  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
 @import '../../style/Approval_nodes';

</style>
